const initialState = {
    data: {}, 
  };
  
  const allImagesResponseReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case "SET_GET_ALL_IMAGES_RESPONSE":
        return {
          ...state,
          data: action.payload, 
        };
      default:
        return state;
    }
  };
  
  export default allImagesResponseReducer;
  